<template>
    <div class="download-app-container" v-bind:class="{loaded: loaded}">
        <div class="close-button">
            <a href="#" @click.prevent="hide()">
                <img src="/images/icon-close.svg" />
            </a>
        </div>
        <div class="container">
            <div class="download-app-content">
                <h2 class="hyper3 download-app-title white"> {{ $t('web.download-app-banner.title') }}</h2>
                <h3 class="hyper6 download-app-subtitle white">{{ $t('web.download-app-banner.subtitle') }}</h3>
                
            </div>
            
            <div class="download-container">
            <div class="search-container">
                <div class="hyper4 white">{{$t('web.download-app-banner.download-now')}}</div>
                <div class="search hyper6 navy-blue bold"><i class="far fa-search"></i>{{$t('web.download-app-banner.hyperair')}}</div>
            </div>
                    
            

            <div class="qr-container">

                <div class="qr-code">
                    <qr-code
                            text="https://link.hyperair.com/JR9k6MFkLV"
                            :size="150"
                            color="#3155A6"
                            bg-color="#FFF"
                            error-level="L">
                    </qr-code>
                </div>
            </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {

        },

        data(){
            return {
                loaded: false
            }
        },

        computed: {

        },

        methods: {
            show(){
                $("body").addClass('show-download-app-container');
            },

            hide(){
                $("body").removeClass('show-download-app-container');
            },

            toggle(){
                $("body").toggleClass('show-download-app-container');
            }
        },

        mounted() {
            this.$events.$on('download-app-container:toggle', () => {
                this.toggle();
            });

            setTimeout(() => {
                this.loaded = true;
            }, 100);
        }
    }
</script>

<style scoped lang="scss">
    .download-app-container{
        background: #3155A6;;
        width: 100%;
        z-index: 2;
        display: none;
        max-height: 0;
        transition: max-height 0.5s;
        overflow: hidden;
        position: relative;

        body.show-download-app-container &{
            max-height: 150px;
        }

        &.loaded{
            display: block;
        }

        .close-button{
            position: absolute;
            top: 0;
            right: 0;
            padding: 8px;
        }

        .container{
            padding: 8px 0;
            display: flex;
            justify-content: space-between;
            align-items: center;
        }

        .download-app-content{
            width:35%;
        }

        .download-app-title{

        }

        .download-app-subtitle{
            margin-bottom: 4px;
        }

        .download-container{
            display:flex;
            
            .search-container{
                display:flex;
                flex-direction: column;
                justify-content: space-between;
                margin-right: 5%;
                width:75%;
                
            
                .search{
                    border-radius: 10px;
                    background: #FFFFFF;
                    padding: 3% 0;
                    padding-left:8%;
                    .far{
                        margin-right:5%;
                    }
                }
            }
            
            .qr-container{
                padding: 8px;
                background: #FFF;
                border-radius: 10px;
            }
        }

    }
</style>
<style lang="scss">
    .download-app-container{
        .qr-container{
            img{
                width: 100px;
            }
        }
    }

    /*body{*/
        /*transform: translate(0,0);*/
        /*transition: transform 0.5s;*/
    /*}*/

    /*body.show-download-app-container{*/
        /*transform: translate(0, 132px);*/
    /*}*/
</style>
